import { ActionType, ErrorTypes, LoadingStatusType } from 'interfaces';
import {
  action,
  createRequestTypes,
  FAILURE,
  REQUEST,
  RequestTypes,
  SUCCESS,
} from 'services/api';
import { GetProductsParams } from 'services/product.api';

export const PRODUCT_BRANDS: RequestTypes =
  createRequestTypes('PRODUCT_BRANDS');
export const PRODUCT_RANGES: RequestTypes =
  createRequestTypes('PRODUCT_RANGES');
export const PRODUCTS: RequestTypes = createRequestTypes('PRODUCTS');
export const SET_PRODUCT_RANGES_LOADING_STATUS =
  'SET_PRODUCT_RANGES_LOADING_STATUS';
export const SET_PRODUCT_BRANDS_LOADING_STATUS =
  'SET_PRODUCT_BRANDS_LOADING_STATUS';
export const SET_PRODUCTS_LOADING_STATUS = 'SET_PRODUCTS_LOADING_STATUS';

export const productBrands = {
  request: (props?: { challengeId?: string }): ActionType =>
    action(PRODUCT_BRANDS[REQUEST], props),
  success: (data: unknown): ActionType =>
    action(PRODUCT_BRANDS[SUCCESS], { data }),
  failure: (error: ErrorTypes): ActionType =>
    action(PRODUCT_BRANDS[FAILURE], { error }),
};
export const productRanges = {
  request: (props?: { challengeId?: string }): ActionType =>
    action(PRODUCT_RANGES[REQUEST], props),
  success: (data: unknown): ActionType =>
    action(PRODUCT_RANGES[SUCCESS], { data }),
  failure: (error: ErrorTypes): ActionType =>
    action(PRODUCT_RANGES[FAILURE], { error }),
};

export const products = {
  request: (params: GetProductsParams, challengeId: number): ActionType =>
    action(PRODUCTS[REQUEST], { params, challengeId }),
  success: (
    data: unknown,
    params: GetProductsParams,
    challengeId: number,
  ): ActionType => action(PRODUCTS[SUCCESS], { data, params, challengeId }),
  failure: (error: ErrorTypes): ActionType =>
    action(PRODUCTS[FAILURE], { error }),
};

export const setProductBrandsLoadingStatus = (
  status: LoadingStatusType,
): ActionType => action(SET_PRODUCT_BRANDS_LOADING_STATUS, { status });

export const setProductRangesLoadingStatus = (
  status: LoadingStatusType,
): ActionType => action(SET_PRODUCT_RANGES_LOADING_STATUS, { status });

export const setProductsLoadingStatus = (
  status: LoadingStatusType,
): ActionType => action(SET_PRODUCTS_LOADING_STATUS, { status });
